import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';

export default function D() {
    const { useLang } = useGlobal();
    const { t } = useLang('powerstreamcooperation');

    return (
        <div className={`powerstream-cooperation-D ${css['powerstream-cooperation-D']}`}>
            <p className="title">{t('secD_title')}</p>
            <div className="text-wrapper">
                <div className="text">
                    {t.rich('secD_text1', {
                        green: (text: string) => <p className="green">{text}</p>,
                    })}
                </div>
                <div className="text">
                    {t.rich('secD_text2', {
                        green: (text: string) => <p className="green">{text}</p>,
                    })}
                </div>
                <div className="text">
                    {t.rich('secD_text3', {
                        green: (text: string) => <p className="green">{text}</p>,
                    })}
                </div>
                <div className="text">
                    {t.rich('secD_text4', {
                        green: (text: string) => <p className="green">{text}</p>,
                    })}
                </div>
            </div>
            <EFVideo
                sources={['/media/power-stream/detail/pc/capture.webm', '/media/power-stream/detail/pc/capture.mp4']}
                autoPlay={true}
                loop={true}
                muted={true}
            />
            <div className="section-pc">
                <div className="section">
                    <div className="text-box">
                        <p className="title">{t('secD_title1')}</p>
                        <p className="desc">{t('secD_desc1')}</p>
                    </div>
                    <EFPicture
                        src="/responsive/picture/powerstream-cooperation/4_1_1366.jpg"
                        srcPad="/responsive/picture/powerstream-cooperation/4_1_768.jpg"
                        srcMobile="/responsive/picture/powerstream-cooperation/4_1_375.jpg"
                        alt={t('secD_title1')}
                    />
                </div>
                <div className="section">
                    <EFPicture
                        src="/responsive/picture/powerstream-cooperation/4_2_1366.jpg"
                        srcPad="/responsive/picture/powerstream-cooperation/4_2_768.jpg"
                        srcMobile="/responsive/picture/powerstream-cooperation/4_2_375.jpg"
                        alt={t('secD_title2')}
                    />
                    <div className="text-box">
                        <p className="title">{t('secD_title2')}</p>
                        <p className="desc">{t('secD_desc2')}</p>
                    </div>
                </div>
                <div className="section">
                    <div className="text-box">
                        <p className="title">{t('secD_title3')}</p>
                        <p className="desc">{t('secD_desc3')}</p>
                    </div>
                    <EFPicture
                        src="/responsive/picture/powerstream-cooperation/4_3_1366.jpg"
                        srcPad="/responsive/picture/powerstream-cooperation/4_3_768.jpg"
                        srcMobile="/responsive/picture/powerstream-cooperation/4_3_375.jpg"
                        alt={t('secD_title3')}
                    />
                </div>
                <div className="section">
                    <EFPicture
                        src="/responsive/picture/powerstream-cooperation/4_4_1366.jpg"
                        srcPad="/responsive/picture/powerstream-cooperation/4_4_768.jpg"
                        srcMobile="/responsive/picture/powerstream-cooperation/4_4_375.jpg"
                        alt={t('secD_title4')}
                    />
                    <div className="text-box">
                        <p className="title">{t('secD_title4')}</p>
                        <p className="desc">{t('secD_desc4')}</p>
                    </div>
                </div>
            </div>
            <div className="section-h5">
                <div className="text-box">
                    <p className="title">{t('secD_title1')}</p>
                    <p className="desc">{t('secD_desc1')}</p>
                    <EFPicture
                        src="/responsive/picture/powerstream-cooperation/4_1_1366.jpg"
                        srcPad="/responsive/picture/powerstream-cooperation/4_1_768.jpg"
                        srcMobile="/responsive/picture/powerstream-cooperation/4_1_375.jpg"
                        alt={t('secD_title1')}
                    />
                </div>
                <div className="text-box">
                    <p className="title">{t('secD_title2')}</p>
                    <p className="desc">{t('secD_desc2')}</p>
                    <EFPicture
                        src="/responsive/picture/powerstream-cooperation/4_2_1366.jpg"
                        srcPad="/responsive/picture/powerstream-cooperation/4_2_768.jpg"
                        srcMobile="/responsive/picture/powerstream-cooperation/4_2_375.jpg"
                        alt={t('secD_title2')}
                    />
                </div>
                <div className="text-box">
                    <p className="title">{t('secD_title3')}</p>
                    <p className="desc">{t('secD_desc3')}</p>
                    <EFPicture
                        src="/responsive/picture/powerstream-cooperation/4_3_1366.jpg"
                        srcPad="/responsive/picture/powerstream-cooperation/4_3_768.jpg"
                        srcMobile="/responsive/picture/powerstream-cooperation/4_3_375.jpg"
                        alt={t('secD_title3')}
                    />
                </div>
                <div className="text-box">
                    <p className="title">{t('secD_title4')}</p>
                    <p className="desc">{t('secD_desc4')}</p>
                    <EFPicture
                        src="/responsive/picture/powerstream-cooperation/4_4_1366.jpg"
                        srcPad="/responsive/picture/powerstream-cooperation/4_4_768.jpg"
                        srcMobile="/responsive/picture/powerstream-cooperation/4_4_375.jpg"
                        alt={t('secD_title4')}
                    />
                </div>
            </div>
        </div>
    );
}
